import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRefresh = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.6654 8.00016C14.6654 11.6802 11.6787 14.6668 7.9987 14.6668C4.3187 14.6668 2.07203 10.9602 2.07203 10.9602M2.07203 10.9602H5.08536M2.07203 10.9602V14.2935M1.33203 8.00016C1.33203 4.32016 4.29203 1.3335 7.9987 1.3335C12.4454 1.3335 14.6654 5.04016 14.6654 5.04016M14.6654 5.04016V1.70683M14.6654 5.04016H11.7054",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgRefresh;
